/* eslint-disable react/no-danger */
import _ from 'lodash';
import { RichTextRenderer } from '@webiny/react-rich-text-renderer';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

const CONTENT_IMAGE_WIDTH = 900;

export const defaultRenderer = {
  // Override the default renderer for "delimiter" block
  //   delimiter: block => {
  //     return <div data-type={block.type} className={"my-custom-delimiter"} />;
  //   },
  paragraph: (block) => (
    <Typography component="p" variant="p">
      <span dangerouslySetInnerHTML={{ __html: block.data.text }} />
    </Typography>
  ),
  header: (block) => {
    const headingLevel = `h${block.data.level}`;
    return (
      <Typography component={headingLevel} variant={headingLevel}>
        <span dangerouslySetInnerHTML={{ __html: block.data.text }} />
      </Typography>
    );
  },
  image: (block) => (
    <figure width="100%" style={{ margin: 0 }}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={`${block.data.file}?width=${CONTENT_IMAGE_WIDTH}`}
        width="100%"
        alt={block.data.caption}
      />
      {block.data.caption && (
        <figcaption className="imageCaption">{block.data.caption}</figcaption>
      )}
    </figure>
  ),
  list: (block) => {
    switch (block.data.style) {
      case 'unordered':
        return (
          <ul className="rte-block-list">
            {block.data.items.map((text, i) => (
              <li key={i} dangerouslySetInnerHTML={{ __html: text }} />
            ))}
          </ul>
        );

      case 'ordered':
        return (
          <ol className="rte-block-list">
            {block.data.items.map((text, i) => (
              <li key={i} dangerouslySetInnerHTML={{ __html: text }} />
            ))}
          </ol>
        );
      default:
        return null;
    }
  },
  inlinePostIntro: (block) => (
    <Box
      width="100%"
      className={classNames(
        block.type,
        _.get(block, 'data.className'),
        _.get(block, 'data.template')
      )}
      sx={{
        backgroundColor: _.get(block, 'data.backgroundColor')
      }}
    >
      <RichTextRenderer data={block.data.body} renderers={defaultRenderer} />
    </Box>
  )
};

const Renderer = ({ data }) => (
  <RichTextRenderer data={data} renderers={defaultRenderer} />
);

Renderer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()).isRequired
};

export default Renderer;
